import F84Game from "../Game";

export default class Fonts {
    public static get DefaultFont(): string {
        return "nunito-black";
    }

    public static get Arial(): string {
        return "Arial";
    }

    public static get LuckiestGuy(): string {
        if (F84Game.Instance.locale == "ru-ru") return "Arial";
        if (F84Game.Instance.locale == "pl-pl") return "Arial";
		return "luckiestguy";
	}

    public static get MaliBoldItalic(): string {
        if (F84Game.Instance.locale == "ru-ru") return this.Arial;
        return "Mali-BoldItalic";
    }

    public static get MaliMediumItalic(): string {
        if (F84Game.Instance.locale == "ru-ru") return this.Arial;
        return "Mali-MediumItalic";
    }

    public static get MaliMedium(): string {
        if (F84Game.Instance.locale == "ru-ru") return this.Arial;
        return "Mali-Medium";
    }
}
